import { z } from 'zod';

/**
 * Browser configuration.
 *
 * Supabase renamed the public key from "anon" to "publishable"; both names are
 * accepted so the same build works against an old or a new project.
 */
const envSchema = z
  .object({
    VITE_SUPABASE_URL: z.url(),
    VITE_SUPABASE_ANON_KEY: z.string().min(20).optional(),
    VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(20).optional(),
    VITE_SITE_URL: z.url().default('http://localhost:5173'),
    VITE_SUPPORT_EMAIL: z.union([z.email(), z.literal('')]).default(''),
    VITE_OFFICIAL_SITE: z.union([z.url(), z.literal('')]).default(''),
    VITE_SENTRY_DSN: z.union([z.url(), z.literal('')]).default(''),
  })
  .refine(
    (value) => Boolean(value.VITE_SUPABASE_ANON_KEY ?? value.VITE_SUPABASE_PUBLISHABLE_KEY),
    {
      message: 'Set VITE_SUPABASE_PUBLISHABLE_KEY (or the legacy VITE_SUPABASE_ANON_KEY).',
      path: ['VITE_SUPABASE_PUBLISHABLE_KEY'],
    },
  )
  .transform((value) => ({
    ...value,
    // The public key is safe to ship; row level security is the boundary.
    supabaseKey: (value.VITE_SUPABASE_ANON_KEY ?? value.VITE_SUPABASE_PUBLISHABLE_KEY) as string,
  }));

const parsed = envSchema.safeParse(import.meta.env);

export const env = parsed.success ? parsed.data : null;

export const envProblems: string[] = parsed.success
  ? []
  : parsed.error.issues.map((issue) => {
      const field = issue.path.join('.') || 'environment';
      return `${field}: ${issue.message}`;
    });

export const isConfigured = parsed.success;
